import { Input } from "@sablier/v2-components/organisms";
import { DEFAULT_DECIMALS } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useAccount, useStreamCurrent } from "~/client/hooks";
import { useFieldAddress, useFieldAmount } from "../logic";

function Amount() {
  const { amount, maximum, onBlur, onChange, onMax, token } = useFieldAmount();
  const { t } = useT();

  return (
    <Input.Amount
      decimals={token.field.value?.decimals || DEFAULT_DECIMALS}
      id={amount.field.id}
      label={{ value: t("modalCovers.withdraw.amount") }}
      isLoading={amount.field.isLoading}
      max={maximum}
      onBlur={onBlur}
      onChange={onChange}
      onMax={onMax}
      placeholder={t("form.placeholder.amount")}
      token={token.field.value}
      value={amount.field.value}
      warning={amount.field.warning}
    />
  );
}

interface LockedChangeProps {
  onChange: (value: boolean) => void;
}

function LockedChange(props: LockedChangeProps) {
  const { address } = useAccount();
  const { stream, isSender } = useStreamCurrent();
  const { t } = useT();

  if (isSender || stream?.sender === stream?.recipient) {
    return (
      <Input.LockedChange
        id={"recipient"}
        label={{ value: t("modalCovers.withdraw.lockedChange") }}
        value={stream?.recipient}
        resolution={_.capitalize(t("words.recipient"))}
      />
    );
  }

  return (
    <Input.LockedChange
      id={"recipient"}
      label={{ value: t("modalCovers.withdraw.lockedChange") }}
      value={address}
      resolution={_.capitalize(t("words.you"))}
      onChange={props.onChange}
    />
  );
}

function Address() {
  const { address, isLoading, label, onBlur, onChange, onFocus } =
    useFieldAddress();
  const { t } = useT();

  return (
    <Input.Address
      id={address.field.id}
      isLoading={isLoading}
      info={isLoading && t("form.placeholder.resolving")}
      label={label}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      placeholder={t("form.placeholder.address")}
      resolution={address.field.resolution?.short}
      value={address.field.value}
      warning={!isLoading && address.field.warning}
    />
  );
}

const Fields = {
  Amount,
  LockedChange,
  Address,
};

export default Fields;
